import { render, staticRenderFns } from "./customBackgroundWrapper.vue?vue&type=template&id=83952d44"
import script from "./customBackgroundWrapper.vue?vue&type=script&lang=js"
export * from "./customBackgroundWrapper.vue?vue&type=script&lang=js"
import style0 from "./customBackgroundWrapper.vue?vue&type=style&index=0&id=83952d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports